import { Component, OnInit } from '@angular/core';
import { HttpClientService } from '../../../Services/http-client.service';
import { AppSettings } from '../../../app-settings';
import { HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ActivatedRoute } from '@angular/router';
import { EventService } from "../../../Services/event.service";
declare var addeventstc:any;
@Component({
  selector: 'app-batch-selector',
  templateUrl: './batch-selector.component.html',
  styleUrls: ['./batch-selector.component.css'],
  animations:[
    trigger('modalPopInOut', [
     transition(':enter', [
           style({opacity: 0}),
           animate('0.3s', style({opacity: 1}))
         ]),
     transition(':leave', [
           style({opacity: 1}),
           animate('0.3s', style({opacity: 0}))
         ])
     ])
  ]
})
export class BatchSelectorComponent implements OnInit {
batches:Object = {};
animationScreensList=[{
    "imageURL" : 'https://cdn.e-gmat.com/wp-content/uploads/2020/08/confirming-selection.png',
    "labelText" : "Confirming your selection..."
  },
  {
    "imageURL" : 'https://cdn.e-gmat.com/wp-content/uploads/2020/08/reserving-spot.png',
    "labelText" : "Reserving a spot for you..."
  },
  {
    "imageURL" : 'https://cdn.e-gmat.com/wp-content/uploads/2020/08/enrollment-confirmed.png',
    "labelText" : "Enrollment confirmed"
  }];

  batchesObject={};
  screenObject={
      "imageURL" : AppSettings.cdnUrl + 'assets/images/confirming-selection.png',
      "labelText" : "Confirming your selection...",
      "screenIndex":0
    };
  propertiesObject={};
  eventName="Live Session Add to Calendar";
  dataAvailable:boolean=false;
  section="";
  accessMode:string="ReadOnly";
  totalNumberOfEnrollments:number=0;
  maxNumberOfEnrollments:number=2;
  maxNumberOfEnrollmentsInTS:number=1;
  showUnenrollControls:boolean=false;
  showEnrollModal:boolean=false;
  showUnenrollModal:boolean=false;
  showAnimationScreenModal:boolean=false;
  showSameTSWarningModal:boolean=false;
  showSameTSWarningModalFirstScreen:boolean=true;
  showSameSubsectionErrorMessage:boolean=false;
  errorAccessMode:boolean=false;
  showToolTip:boolean=false;
  showDescription:boolean=false;
  disableAccess:boolean=false;

  batchInfo:any;
  unenrollBatchForm:FormGroup;
  unenrollValidationTokenString=new RegExp("^unenroll$","i");

  infoIconURL:string = AppSettings.cdnUrl + "assets/images/info-icon.png";
  infoIconDisabledURL:string = AppSettings.cdnUrl + "assets/images/info-icon-disabled.png";
  exitButtonURL:string = AppSettings.cdnUrl + "assets/images/exit-button.png";
  confirmIconURL:string = AppSettings.cdnUrl + "assets/images/confirm-icon.png";
  exitIconURL:string = AppSettings.cdnUrl + "assets/images/exit-icon.png";
  videoIconURL:string = AppSettings.cdnUrl + "assets/images/video-icon.png";
  lsVideeoIconURL:string = AppSettings.cdnUrl + "assets/images/ls-video-icon.png";
  loadingCircleURL:string = AppSettings.loadingCircleImageURL;

  constructor(private httpClientService:HttpClientService, private formbuilder: FormBuilder, private route:ActivatedRoute, private eventService: EventService) {
    this.unenrollBatchForm = formbuilder.group({
      'batchUnenroll': ['', [Validators.required, Validators.pattern(this.unenrollValidationTokenString)]]
    });

   }

  get batchUnenroll() { return this.unenrollBatchForm.get('batchUnenroll'); }

  ngOnInit() {
    this.route.paramMap.subscribe( paramMap => {
        this.section = paramMap.get('section');
        if(this.section)
        {
          this.getBatches();
        }
    });
}

  getBatches()
  {
    this.dataAvailable=false;
      this.httpClientService.get(`${AppSettings.restApiUrl}/api/batch/eligible/${this.section}/getAll`, new HttpHeaders()).subscribe((data)=>{
        if(data['success'])
        {
          this.batches = data;
          this.accessMode = data['userMode'];
          this.sortAndFormatBatches('availableBatches');
          this.sortAndFormatBatches('enrolledBatches');
          this.calculateTotalNumberOfEnrollments();
          this.dataAvailable=true;
          this.showCalendarLinkToolTip();
          setTimeout(()=>{
            if(addeventstc!=undefined)
            {
              this.addEventServiceSetup();
            }
          },1000);
        }
      });
  }
  addEventServiceSetup(){
    let then = this;
    addeventstc.refresh();
    addeventstc.register('button-dropdown-click', function(obj,event){
      then.propertiesObject['Calendar Client'] = obj.service;
      then.eventService.track(then.eventName, then.propertiesObject);
    });
  }
  addToCalendarEventSetup(timeSlot)
  {
    let batchObject = this.batchesObject['enrolledBatches'][timeSlot][0];
    this.propertiesObject['Calendar Batch Name'] = batchObject['batchName'];
    this.propertiesObject['Calendar Batch Subsection'] = batchObject['subSection'];
    this.propertiesObject['Calendar Course'] = this.section;
    this.propertiesObject['Calendar Batch Start Date'] = batchObject['batchStartDate'];
  }
  calculateTotalNumberOfEnrollments()
  {
    if(this.batchesObject.hasOwnProperty("enrolledBatches"))
    {
      this.totalNumberOfEnrollments = Object.keys(this.batchesObject['enrolledBatches']).length;
      if(this.totalNumberOfEnrollments==this.maxNumberOfEnrollments)
      {
        this.batchesObject['enrolledBatches']['Time Slot 1'][0]['expandSchedule']=true;
        this.batchesObject['enrolledBatches']['Time Slot 2'][0]['expandSchedule']=true;
      }
    }
  }
  fetchFullSchedule(batch)
  {
    if(batch['batchSessionDetails'].length>0)
    {
      batch['expandSchedule']=batch['expandSchedule']?false:true;
    }
    else
    {
      if(batch['expandSchedule'])
      {
        batch['expandSchedule']=batch['expandSchedule']?false:true;
      }
      else
      {
          this.fetchSchedule(batch);
      }

    }
  }

  fetchSchedule(batch)
  {
      let batchID = batch['batchID'];
      this.httpClientService.get(`${AppSettings.restApiUrl}/api/batch/schedule/${batchID}`,new HttpHeaders()).subscribe((data)=>{
        if(data['success'])
        {
          batch['batchSessionDetails']=data['batchSessionDetails'];
          batch['expandSchedule']=true;
        }
        else
        {
          batch['expandSchedule']=true;
        }
      });
  }

  sortAndFormatBatches(batchLabel)
  {
    this.batchesObject[batchLabel] = {};
    for(let i = 0; i < this.batches[batchLabel].length; i++)
      {
        let currentObject = this.batches[batchLabel][i];
        currentObject['expandSchedule']=false;
        if(!this.batchesObject[batchLabel].hasOwnProperty(currentObject['slotName']))
        {
          this.batchesObject[batchLabel][currentObject['slotName']] = [];
        }
        this.batchesObject[batchLabel][currentObject['slotName']].push(currentObject);
      }
  }

  enrollUserInBatch(batch)
  {
    this.batchInfo = batch;
    let timeSlot = batch['slotName'];
    let subSection = batch['subSection'];
    let numOfEnrollmentsInTS = this.getTotalNumberOfEnrollMentsInTS(timeSlot);
    let enrolledInSS = this.checkIfUserEnrolledInSameSS(subSection);
    if(batch['userEnrolled'])
    {
      this.showEnrollModal = true;
    }
    else
    {
      if(numOfEnrollmentsInTS < this.maxNumberOfEnrollmentsInTS)
      {
        this.showEnrollModal = true;
        if(enrolledInSS)
        {
          this.showSameSubsectionErrorMessage = true;
        }
      }
      else
      {
        this.showSameTSWarningModal = true;
      }
    }
  }
  unenerollUserFromBatch(batch)
  {
    this.showUnenrollModal=true;
    this.batchInfo = batch;
  }
  getTotalNumberOfEnrollMentsInTS(timeSlot)
  {
    let itemsLength =  0;
    if(this.batchesObject['enrolledBatches'].hasOwnProperty(timeSlot))
    {
        itemsLength = this.batchesObject['enrolledBatches'][timeSlot].length;
    }
    return itemsLength;
  }
  checkIfUserEnrolledInSameSS(subSection)
  {
    if(this.batchesObject['enrolledBatches'].hasOwnProperty("Time Slot 1"))
    {
      return this.batchesObject['enrolledBatches']["Time Slot 1"][0]['subSection'] == subSection;
    }
    else if(this.batchesObject['enrolledBatches'].hasOwnProperty("Time Slot 2"))
    {
      return this.batchesObject['enrolledBatches']["Time Slot 2"][0]['subSection'] == subSection;
    }
    else
    {
      return false;
    }
  }
  cancelConfirmSubscriptionModal()
  {
      this.showEnrollModal=false;
      this.errorAccessMode=false;
      this.showDescription=false;
      this.disableAccess = false;
      this.showSameSubsectionErrorMessage=false;
  }
  cancelUnenrollModal()
  {
      this.showUnenrollModal=false;
      this.unenrollBatchForm.reset();
      this.errorAccessMode=false;
      this.disableAccess=false;
  }
  cancelSameTSWarningModal()
  {
    this.showSameTSWarningModal=false;
    this.showSameTSWarningModalFirstScreen=true;
  }
  blurBackground(action:string)
  {
     if(action=== 'add')
     {
       document.body.classList.add('coursePopIn');
     }
     else
     {
       document.body.classList.remove('coursePopIn');
     }
  }

  toggleBatchEnrollment()
  {
      this.showUnenrollControls = this.showUnenrollControls?false:true;
  }
  animateScreen()
  {
    let index=1;
    let animateScreenInterval = setInterval(()=>{
      if(index < this.animationScreensList.length)
      {
        this.screenObject['screenIndex']=index;
        this.screenObject['imageURL'] = this.animationScreensList[index]['imageURL'];
        this.screenObject['labelText'] = this.animationScreensList[index]['labelText'];
        // this.screenObject['screenIndex']=index;
        index += 1;
      }
      else
      {
        clearInterval(animateScreenInterval);
      }
    },1500);
  }
  resetAnimationScreenModal()
  {
    let index = 0;
    this.screenObject['screenIndex'] = index;
    this.screenObject['imageURL'] = this.animationScreensList[index]['imageURL'];
    this.screenObject['labelText'] = this.animationScreensList[index]['labelText'];
  }
  showToolTipOnLoadConfig(batch)
  {
    localStorage.setItem("showToolTip",batch['slotName']);
  }
  showCalendarLinkToolTip()
  {
    let slotName = localStorage.getItem('showToolTip');
    if(slotName!=null && slotName!=undefined)
    {
      this.showToolTip = true;
      if(this.batchesObject['enrolledBatches'].hasOwnProperty(slotName))
      {
          this.batchesObject['enrolledBatches'][slotName][0]['showToolTip']=true;
          this.hideToolTipAfterDelay(slotName);
      }
    }
  }

  hideToolTipAfterDelay(timeSlot)
  {
      setTimeout(()=>{
        this.showToolTip = false;
        localStorage.removeItem('showToolTip');
        this.batchesObject['enrolledBatches'][timeSlot][0]['showToolTip']=false;
      },1500);
  }
  enrollUser(batch)
  {
    if(this.accessMode!="ReadOnly")
    {
      let batchID = batch['batchID'];
      this.httpClientService.post(`${AppSettings.restApiUrl}/api/batch/enroll/${batchID}`,{},new HttpHeaders()).subscribe((data)=>{
        if(data['success'])
        {
          this.showToolTipOnLoadConfig(batch);
        }
      });
    }
  }
  unenrollUser(batch)
  {
    this.showUnenrollControls=false;
    if(this.accessMode!="ReadOnly")
    {
      let batchID = batch['batchID'];
      this.httpClientService.post(`${AppSettings.restApiUrl}/api/batch/unenroll/${batchID}`,{},new HttpHeaders()).subscribe((data)=>{
        if(data.success)
        {
          this.unenrollBatchForm.reset();
          this.showUnenrollModal=false;
          this.getBatches();
        }
      });
    }
    else
    {
      this.errorAccessMode=true;
      this.disableAccess=true;
    }
  }
  confirmEnrollmentAndShowAnimation(batch)
  {
    if(this.accessMode!='ReadOnly')
    {
      this.enrollUser(batch);
      this.showEnrollModal=false;
      this.showAnimationScreenModal=true;
      this.animateScreen();
    }
    else
    {
      this.errorAccessMode = true;
      this.disableAccess = true;
    }
  }
  toggleShowDescription()
  {
    this.showDescription = !this.showDescription;
  }
}
